import type { InterleavedSearchResultContext } from "./schema/InterleavedSearchResultContext";

interface InterleavedSearchExperimentStore {
    currentInterleavedSearchResultContext?: InterleavedSearchResultContext;
    /**
     * Whether cloud cache crawling is complete, keyed by account key. A missing entry indicates
     * that the state has not been resolved for the account.
     */
    isCloudCacheCrawlingCompleteByAccountKey: Map<string, boolean>;
}

const store: InterleavedSearchExperimentStore = {
    currentInterleavedSearchResultContext: undefined,
    isCloudCacheCrawlingCompleteByAccountKey: new Map(),
};

/**
 * Gets the shared interleaved search experiment store.
 */
export default function getInterleavedSearchExperimentStore(): InterleavedSearchExperimentStore {
    return store;
}
